export default ({ request }) => ({
  prebuiltSampleBarcodeListApi(data = {}) {
    return request({
      url: '/master/prebuilt/sample/barcode/list',
      method: 'post',
      data
    })
  },
  prebuiltSampleBarcodeGenerationApi(data = {}) {
    return request({
      url: '/master/prebuilt/sample/barcode/generation',
      method: 'post',
      data
    })
  },
  prebuiltSampleBarcodePrintTimeApi(data = {}) {
    return request({
      url: '/master/prebuilt/sample/barcode/printTime',
      method: 'post',
      data
    })
  },
})
